import { IStateProvider } from 'angular-ui-router';

import { SdcStateBuilder } from './sdc-state-builder.service';

CreditGapsRouteConfig.$inject = ['$stateProvider'];

const SDC_KEY = 'credit-gaps';

export function CreditGapsRouteConfig($stateProvider: IStateProvider) {
  const creditGapsGridState = SdcStateBuilder.buildGridState(SDC_KEY);
  const creditGapsWizardState = SdcStateBuilder.buildCreditGapsWizardState(SDC_KEY);
  const creditGapsProfileState = SdcStateBuilder.buildProfileState(SDC_KEY);

  $stateProvider

    .state(`main.school.new-sdc.${SDC_KEY}`, {
      abstract: true,
      url: `/${SDC_KEY}`,
      template: `
      <sdc-root
      current-user="$resolve.currentUser"
      current-state="$resolve.currentState">
      </sdc-root>
        `,
    })

    .state(`main.school.new-sdc.${SDC_KEY}.grid`, creditGapsGridState)

    .state(`main.school.new-sdc.${SDC_KEY}.wizard`, creditGapsWizardState)

    .state(`main.school.new-sdc.${SDC_KEY}.profile`, creditGapsProfileState);
}
